import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Header, Footer } from "../components/layout/SiteChrome";

export default function ContactPage() {
  const [form, setForm] = useState({ name: "", phone: "", email: "", message: "" });
  const [sent, setSent] = useState(false);

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const subject = encodeURIComponent(`Contact request from ${form.name || "a visitor"}`);
    const body = encodeURIComponent(`Name: ${form.name}\nPhone: ${form.phone}\nEmail: ${form.email}\n\n${form.message}`);
    window.location.href = `mailto:info@truevaluemobiles.in?subject=${subject}&body=${body}`;
    setSent(true);
  };

  const inputStyle: React.CSSProperties = {
    width: "100%", padding: "13px 15px", border: "1.5px solid var(--border)", borderRadius: 10,
    fontSize: 14, fontFamily: "var(--font-body)", color: "var(--text)", background: "var(--bg)",
    outline: "none", transition: "border-color 0.2s", boxSizing: "border-box",
  };

  return (
    <div className="page-bg">
      <Header />

      {/* Header */}
      <section style={{ background: "var(--indigo)", padding: "40px 20px 44px" }}>
        <div style={{ maxWidth: 1000, margin: "0 auto" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, color: "rgba(255,255,255,0.6)", marginBottom: 16 }}>
            <Link to="/" style={{ color: "rgba(255,255,255,0.6)", textDecoration: "none", transition: "color 0.2s" }}
              onMouseEnter={e => (e.currentTarget.style.color = "#fff")}
              onMouseLeave={e => (e.currentTarget.style.color = "rgba(255,255,255,0.6)")}>
              Home
            </Link>
            <span>›</span>
            <span style={{ color: "#fff", fontWeight: 600 }}>Contact</span>
          </div>
          <h1 style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: "clamp(26px,4vw,38px)", color: "#fff", letterSpacing: "-0.8px", marginBottom: 8 }}>
            Contact Us
          </h1>
        </div>
      </section>

      {/* Body */}
      <section style={{ maxWidth: 1000, margin: "0 auto", padding: "48px 20px 72px" }}>
        <div style={{ display: "grid", gridTemplateColumns: "1.5fr 1fr", gap: 24, alignItems: "start" }} className="contact-grid">
          {/* Send a Message */}
          <div style={{ background: "var(--surface)", border: "1.5px solid var(--border)", borderRadius: 18, padding: "32px 28px", boxShadow: "var(--shadow-sm)" }}>
            <h2 style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: 24, color: "var(--text)", marginBottom: 24 }}>Send a Message</h2>

            {sent && (
              <div style={{ background: "var(--indigo-light)", border: "1.5px solid var(--border-bright)", borderRadius: 12, padding: "14px 16px", fontSize: 14, color: "var(--indigo)", marginBottom: 18 }}>
                ✅ Your email app is opening — just press send and our team will reply within 24 hours.
              </div>
            )}

            <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }} className="contact-fields">
                <label style={{ display: "flex", flexDirection: "column", gap: 6, fontSize: 13, fontWeight: 600, color: "var(--text)" }}>
                  Your Name *
                  <input required value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="e.g. Rahul Verma" style={inputStyle} />
                </label>
                <label style={{ display: "flex", flexDirection: "column", gap: 6, fontSize: 13, fontWeight: 600, color: "var(--text)" }}>
                  Phone Number *
                  <input required value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} placeholder="+91 98XXXXXXXX" style={inputStyle} />
                </label>
              </div>
              <label style={{ display: "flex", flexDirection: "column", gap: 6, fontSize: 13, fontWeight: 600, color: "var(--text)" }}>
                Email Address
                <input type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} placeholder="you@example.com" style={inputStyle} />
              </label>
              <label style={{ display: "flex", flexDirection: "column", gap: 6, fontSize: 13, fontWeight: 600, color: "var(--text)" }}>
                Your Message *
                <textarea required rows={5} value={form.message} onChange={e => setForm({ ...form, message: e.target.value })} placeholder="How can we help you?" style={{ ...inputStyle, resize: "vertical" }} />
              </label>
              <button type="submit" style={{
                background: "linear-gradient(135deg, var(--brand), var(--brand-dark))",
                color: "#fff", border: "none", borderRadius: 12, padding: "14px 36px", fontSize: 15, fontWeight: 700,
                fontFamily: "var(--font-display)", cursor: "pointer", boxShadow: "0 8px 24px rgba(255,107,53,0.3)",
                transition: "all 0.2s", alignSelf: "flex-start",
              }}
                onMouseEnter={e => { const el = e.currentTarget as HTMLElement; el.style.transform = "translateY(-1px)"; el.style.boxShadow = "0 12px 32px rgba(255,107,53,0.4)"; }}
                onMouseLeave={e => { const el = e.currentTarget as HTMLElement; el.style.transform = ""; el.style.boxShadow = "0 8px 24px rgba(255,107,53,0.3)"; }}>
                Send Message
              </button>
            </form>
          </div>

          {/* Contact Info */}
          <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
            <div style={{ background: "var(--surface)", border: "1.5px solid var(--border)", borderRadius: 18, padding: "28px 24px", boxShadow: "var(--shadow-sm)" }}>
              <h3 style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: 18, color: "var(--text)", marginBottom: 18 }}>Contact Info</h3>
              <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
                <div style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
                  <span style={{ fontSize: 18, flexShrink: 0, width: 26, textAlign: "center" }}>📍</span>
                  <div>
                    <div style={{ fontSize: 12, fontWeight: 700, color: "var(--text3)", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 3 }}>Address</div>
                    <p style={{ fontSize: 14, color: "var(--text)", lineHeight: 1.55 }}>
                      42 Cyber Hub, Gurugram,
                      <br />
                      Haryana 122002, India
                    </p>
                  </div>
                </div>
                <div style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
                  <span style={{ fontSize: 18, flexShrink: 0, width: 26, textAlign: "center" }}>📞</span>
                  <div>
                    <div style={{ fontSize: 12, fontWeight: 700, color: "var(--text3)", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 3 }}>Office</div>
                    <a href="tel:+918800880101" style={{ fontSize: 14, fontWeight: 600, color: "var(--brand)", textDecoration: "none" }}
                      onMouseEnter={e => (e.currentTarget.style.textDecoration = "underline")}
                      onMouseLeave={e => (e.currentTarget.style.textDecoration = "none")}>
                      +91 8800880101
                    </a>
                  </div>
                </div>
                <div style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
                  <span style={{ fontSize: 18, flexShrink: 0, width: 26, textAlign: "center" }}>✉️</span>
                  <div>
                    <div style={{ fontSize: 12, fontWeight: 700, color: "var(--text3)", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 3 }}>Email</div>
                    <a href="mailto:info@truevaluemobiles.in" style={{ fontSize: 14, fontWeight: 600, color: "var(--brand)", textDecoration: "none" }}
                      onMouseEnter={e => (e.currentTarget.style.textDecoration = "underline")}
                      onMouseLeave={e => (e.currentTarget.style.textDecoration = "none")}>
                      info@truevaluemobiles.in
                    </a>
                  </div>
                </div>
                <div style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
                  <span style={{ fontSize: 18, flexShrink: 0, width: 26, textAlign: "center" }}>🕘</span>
                  <div>
                    <div style={{ fontSize: 12, fontWeight: 700, color: "var(--text3)", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 3 }}>Working Hours</div>
                    <p style={{ fontSize: 14, color: "var(--text)", lineHeight: 1.55 }}>Mon–Sat, 9AM – 8PM</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}